export default {
  行业协会: '行业协会',
  会员单位: '会员单位',
  家: '家',
  干货分享: '干货分享',
  专家访谈: '专家访谈',
  行业头条: '行业头条',
  '信息更新中，敬请期待': '信息更新中，敬请期待',
  '请完善企业信息, 方便采购商与您联系': '请完善企业信息, 方便采购商与您联系',
  '30天免费特权': '30天免费特权',
  恭喜获得: '恭喜获得',
  鸿运当头: '鸿运当头',
  供应链企业: '供应链企业',
  供应链产品: '供应链产品',
  申请入驻: '申请入驻',
  加入: '加入',
  请选择产品品类: '请选择产品品类',
  申请入链: '申请入链',
  企业负责人: '企业负责人',
  请输入企业负责人: '请输入企业负责人',
  产品分类: '产品分类',
  '请阅读勾选协议书！': '请阅读勾选协议书！',
  供应链品牌: '供应链品牌',
  // 元宇宙会客厅: '元宇宙会客厅',
  供应链需求: '供应链需求',
  距结束还剩: '距结束还剩',
  '搜索产品/采购/资讯/企业': '搜索产品/采购/资讯/企业',
  供应链管理: '供应链管理',
  进入平台: '进入平台',
  产品品类: '产品品类',
  新增品牌: '新增品牌',
  客户获客总数: '客户获客总数',
  '若同步异常, 请选择否': '若同步异常, 请选择否',
  您已加入: '您已加入',
  到期: '到期',
  去管理: '去管理',
  供应链: '供应链',
  产品类别: '产品类别',
  姓名不能超过30个字符: '姓名不能超过30个字符',
  请输入产品类别: '请输入产品类别',
  '立即升级/续费': '立即升级/续费',
}
